import { problemText, type ApiError } from '@/shared/api';

/**
 * Die Buchungsdienste schicken `detail` als Entwicklertext, teils auf Englisch. Gezeigt wird der
 * Satz zum Code; der Code bleibt für den Support dabei, auch wenn kein Satz bekannt ist.
 */
const TEXT: Record<string, string> = {
  booking_stay_completed: 'Der Gast ist abgereist – bearbeiten und stornieren geht nicht mehr.',
  booking_overlap: 'Der Zeitraum überschneidet sich mit einer anderen Buchung.',
  booking_over_block: 'Im Zeitraum liegt eine Kalendersperre.',
  booking_already_cancelled: 'Die Buchung ist schon storniert.',
  booking_cancelled: 'Die Buchung ist schon storniert.',
  booking_noshow_not_editable: 'Eine nicht angereiste Buchung lässt sich nicht mehr ändern.',
  ota_booking_not_editable: 'Eine Kanalbuchung ändert der Gast über den Kanal.',
  booking_not_found: 'Diese Buchung gibt es nicht mehr.',
  cancellation_in_progress: 'Für diese Buchung läuft schon ein Storno – bitte die Seite neu laden.',
  cancellation_payment_processing:
    'Die Zahlung wird gerade noch verarbeitet – bitte gleich noch einmal versuchen.',
  cancellation_payment_unknown: 'Der Zahlungsstatus lässt sich gerade nicht sicher prüfen.',
  cancellation_payment_retry_required: 'Die Erstattung ging nicht durch – bitte erneut versuchen.',
  cancellation_paid_admin_required: 'Eine bezahlte Buchung kann nur die Verwaltung stornieren.',
};

export function bookingMutationErrorText(problem: ApiError, fallback: string): string {
  return problemText(problem, fallback, { known: TEXT });
}

export function isStayCompleted(problem: ApiError | null): boolean {
  return problem?.title === 'booking_stay_completed';
}
